import * as React from 'react';
import { AsidePanelContext } from '../../../../../asidePanel/components/AsidePanel/constants';
import { CLASS_BOARD_DETAILS_SECTION } from '../../../../constants';
import { SettingsSection } from '../../../../../../base/components/SettingsSection/SettingsSection';
import './_TemplateSection.scss';
import { TemplateHOC } from '../../hocs/TemplateHOC/TemplateHOC';
import { EBoardSetting } from '../../../TabDetails/components/TabDetails/types';
import { TutorialHOC } from '../../../Tutorial/hocs/TutorialHOC/TutorialHOC';
import { TEMPLATE_SECTION_TITLE } from './constants';
import { ITemplateSectionProps } from './types';

export function TemplateSection ({
    isEssentialFeature,
    isShow,
}: ITemplateSectionProps) {
    if (!isShow) return;

    const { boardId } = React.useContext(AsidePanelContext);
    const className = CLASS_BOARD_DETAILS_SECTION + ' ' + CLASS_BOARD_DETAILS_SECTION + '--template';

    return (
        <>
            <TutorialHOC boardSetting={EBoardSetting.TEMPLATE} />
            <SettingsSection
                className={className}
                title={TEMPLATE_SECTION_TITLE}
                isEssentialFeature={isEssentialFeature}
            >
                <TemplateHOC
                    boardId={boardId}
                />
            </SettingsSection>
        </>
    );
};
